"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfUi = void 0;
const router_1 = require("client/components/router");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
require("./pdf-ui.less");
const pdfStore_1 = require("./pdfStore");
let PdfUi = class PdfUi extends React.Component {
    constructor() {
        super(...arguments);
        this.claimId = "";
    }
    componentDidMount() {
        this.claimId = window.location.pathname.split("/").pop();
        if (this.claimId) {
            pdfStore_1.pdfStore.getClaimPDFs(this.claimId);
        }
    }
    render() {
        if (store_1.usersStore.user.value.groupId > 4) {
            router_1.RouteManager.transitionTo("/dashboard");
        }
        // console.log(pdfStore.entirePDFPath);
        return (React.createElement("div", { className: "pdf-container" },
            React.createElement("div", { className: "pdf-item" },
                React.createElement("iframe", { className: "iframe-style", src: pdfStore_1.pdfStore.entirePDFPath || pdfStore_1.pdfStore.defaultPDFPath })),
            React.createElement("div", { className: "pdf-item" },
                React.createElement("iframe", { className: "iframe-style", src: pdfStore_1.pdfStore.labelPDFPath || pdfStore_1.pdfStore.defaultPDFPath }))));
    }
};
__decorate([
    mobx_1.observable
], PdfUi.prototype, "claimId", void 0);
PdfUi = __decorate([
    mobx_react_1.observer
], PdfUi);
exports.PdfUi = PdfUi;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/pdf-ui/pdf-ui.tsx
// module id = 3857
// module chunks = 0